import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { isInIframe } from "helpers/app";
import { withVar } from "themes/helpers";

interface IStyledColumns {
  overflowHidden?: boolean;
}

const StyledColumns = styled.div<IStyledColumns>`
  display: flex;
  align-items: stretch;
  align-content: stretch;
  width: 100%;
  height: 100%;
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.overflowHidden && "overflow: hidden"
  };
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface StyledColumnProps {
  border: boolean;
  minWidth?: number;
  relativeWidth?: number;
  totalRelativeWidth?: number;
  zIndex?: number;
}

const getColumnFlexBasis = (props: StyledColumnProps): string => {
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  if (props.totalRelativeWidth > 0 && props.relativeWidth > 0) {
    // Calc relative flex-basis of current column(in percentages)
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    return `${((props.relativeWidth / props.totalRelativeWidth) * 100).toFixed(5)}%`;
  }

  return "auto";
};

const StyledColumn = styled.div<StyledColumnProps>`
  box-sizing: border-box;
  height: 100%;
  border-left: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.border ? `1px solid ${withVar(DesignToken.BorderBasicSecondary)}` : "none")
  };
  min-width: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => `${props.minWidth}px`
  };
  flex-grow: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.relativeWidth ? props.relativeWidth : 1)
  };
  flex-shrink: 1;
  flex-basis: ${getColumnFlexBasis};
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.zIndex ? `z-index: ${props.zIndex}` : "")
  };
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface NonOptionalStackableViewInterface {
  stackShowBackButton: boolean;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isStackableView = (node: any): node is React.ReactElement<NonOptionalStackableViewInterface> => node;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface ColumnsProps {
  mobileLayout: boolean;
  focusedColumn: number;
  hiddenColumns: Set<number>;
  minWidths?: number[];
  relativeWidths?: number[];
  overflowHidden?: boolean;
  zIndices?: number[];
  children: React.ReactNode;
  noBorder?: boolean;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-empty-object-type
interface ColumnsState {}

export default class ColumnsView extends React.Component<ColumnsProps, ColumnsState> {
  private isColumnHidden = (
    mobileLayout: boolean,
    columnIndex: number,
    focusedColumnIndex: number,
    hiddenColumns: Set<number>
  ): boolean => {
    const isEmbeddedInIframe = isInIframe();

    if (mobileLayout && !isEmbeddedInIframe) {
      return columnIndex !== focusedColumnIndex;
    }

    return hiddenColumns.has(columnIndex);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const {
      mobileLayout,
      focusedColumn,
      hiddenColumns,
      minWidths,
      relativeWidths,
      overflowHidden,
      zIndices,
      children,
      noBorder,
    } = this.props;
    const totalRelativeWidth = (relativeWidths || []).reduce((r, v) => r + v, 0);

    return (
      <StyledColumns overflowHidden={overflowHidden}>
        {/* @ts-expect-error TS(2345): Argument of type 'ReactNode' is not assignable to ... Remove this comment to see the full error message */}
        {React.Children.map(children, (child: React.ReactChild, index: number) =>
          isStackableView(child) ? (
            <StyledColumn
              /* eslint-disable-next-line react/no-array-index-key */
              key={index}
              border={!mobileLayout && index !== 0 && !noBorder}
              minWidth={minWidths && minWidths[index]}
              relativeWidth={relativeWidths && relativeWidths[index]}
              totalRelativeWidth={totalRelativeWidth}
              zIndex={zIndices && zIndices[index]}
              hidden={this.isColumnHidden(mobileLayout, index, focusedColumn, hiddenColumns)}
            >
              {React.cloneElement(child, {
                stackShowBackButton: mobileLayout && index !== 0,
              })}
            </StyledColumn>
          ) : null
        )}
      </StyledColumns>
    );
  }
}
